import { useContext } from 'react'
import { ScreenDimensionsContext } from '../../contexts/ScreenDimensionsContext.context'

const useScreenDimensionsContext = () => {
  const data = useContext(ScreenDimensionsContext)
  return data
}

export default useScreenDimensionsContext
